module.exports = __webpack_public_path__ + "img/incomeForecastBlue.ebca9fbd.png";